import React from 'react'
import style from './AddNewButton.module.css'

interface Props {
  onClick: () => void
}

export default function AddNewButton(props: Props) {
  const renderPlus = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#AAAAAA" />
      <mask id="path-2-inside-1" fill="white">
        <path d="M13 18L11 18L11 6L13 6L13 18Z" />
      </mask>
      <path
        d="M13 18L13 20L15 20L15 18L13 18ZM11 18L9 18L9 20L11 20L11 18ZM11 6L11 4L9 4L9 6L11 6ZM13 6L15 6L15 4L13 4L13 6ZM13 16L11 16L11 20L13 20L13 16ZM13 18L13 6L9 6L9 18L13 18ZM11 8L13 8L13 4L11 4L11 8ZM11 6L11 18L15 18L15 6L11 6Z"
        fill="#FAFAFA"
        mask="url(#path-2-inside-1)"
      />
      <mask id="path-4-inside-2" fill="white">
        <path d="M6 13L6 11L18 11L18 13L6 13Z" />
      </mask>
      <path
        d="M6 13L4 13L4 15L6 15L6 13ZM6 11L6 9L4 9L4 11L6 11ZM18 11L20 11L20 9L18 9L18 11ZM18 13L18 15L20 15L20 13L18 13ZM8 13L8 11L4 11L4 13L8 13ZM6 13L18 13L18 9L6 9L6 13ZM16 11L16 13L20 13L20 11L16 11ZM18 11L6 11L6 15L18 15L18 11Z"
        fill="#FAFAFA"
        mask="url(#path-4-inside-2)"
      />
    </svg>
  )
  return (
    <div className={style.root} onClick={props.onClick}>
      {renderPlus()} <span>New</span>
    </div>
  )
}
